<template>
  <div>
    <el-form :inline="true" :model="query" @keyup.enter.native="load">
      <el-form-item label="会计年度">
        <el-select v-model="query.year" size="small" style="width:100px" @change="onYearChange">
          <el-option v-for="y in years" :key="y" :label="y" :value="y" />
        </el-select>
      </el-form-item>
      <el-form-item label="期号">
        <el-select v-model="query.periodNo" size="small" style="width:80px" @change="load">
          <el-option v-for="n in 12" :key="n" :label="n" :value="n" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('finance:subjectBalance:list')" type="primary" size="small" @click="load">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column prop="subjectCode" label="科目编码" width="120" />
      <el-table-column prop="subjectName" label="科目名称" min-width="160" />
      <el-table-column prop="openingDebit" label="期初借方" width="110" align="right"><template slot-scope="s">{{ money(s.row.openingDebit) }}</template></el-table-column>
      <el-table-column prop="openingCredit" label="期初贷方" width="110" align="right"><template slot-scope="s">{{ money(s.row.openingCredit) }}</template></el-table-column>
      <el-table-column prop="periodDebit" label="本期借方" width="110" align="right"><template slot-scope="s">{{ money(s.row.periodDebit) }}</template></el-table-column>
      <el-table-column prop="periodCredit" label="本期贷方" width="110" align="right"><template slot-scope="s">{{ money(s.row.periodCredit) }}</template></el-table-column>
      <el-table-column prop="closingDebit" label="期末借方" width="110" align="right"><template slot-scope="s">{{ money(s.row.closingDebit) }}</template></el-table-column>
      <el-table-column prop="closingCredit" label="期末贷方" width="110" align="right"><template slot-scope="s">{{ money(s.row.closingCredit) }}</template></el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '../../api/request'
import auth from './financeAuth'
import periodQuery from './financePeriodQuery'

export default {
  mixins: [auth, periodQuery],
  data() { return { list: [] } },
  created() { this.loadLedgerYears(true) },
  methods: {
    load() {
      if (!this.query.year || !this.query.periodNo) { this.$message.warning('请选择会计年度和期号'); return }
      this.loading = true
      request.get('/finance/subjectBalance/list', { params: this.periodParams() })
        .then(res => { this.list = res.data || [] })
        .finally(() => { this.loading = false })
    }
  }
}
</script>
